export default "__VITE_ASSET__Be9Opwnu__"